import React from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';

import HistoryLogsWrapper from '../../../../components/history-logs-wrapper';

function ForecastCategoryRenderer(props) {
  const { value, data, node } = props;
  const isGrouped = node && node.group;
  if (value === null) {
    return null;
  }

  const comp = (<span>{value}</span>);
  if (isGrouped) {
    // groupping
    return comp;
  }

  const isForecastSlipped = data.is_forecast_slipped;

  return (
    <HistoryLogsWrapper type="forecast_category_name" opportunity={data}>
      <span className={isForecastSlipped ? 'text-danger' : ''}>
        {comp}{isForecastSlipped && <span>&nbsp;<Fa name="exclamation-triangle" /></span>}
      </span>
    </HistoryLogsWrapper>
  );
}

ForecastCategoryRenderer.propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    is_forecast_slipped: PropTypes.bool,
  }),
  node: PropTypes.shape({
    group: PropTypes.bool,
  }),
};
ForecastCategoryRenderer.defaultProps = {
  value: null,
  node: null,
  data: null,
};

export default ForecastCategoryRenderer;
